export default "__VITE_ASSET__C8e1NWkn__"